import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { notifyLocationChange } from '@reed/analytics';

// Reports every route change to the analytics runtime: it re-checks the GTM
// gate and sends a sanitised virtual page view (#1458).
export function AnalyticsRouteListener(): null {
  const location = useLocation();

  useEffect(() => {
    notifyLocationChange();
  }, [location.pathname, location.search, location.hash]);

  return null;
}
